module.exports = __webpack_public_path__ + "static/img/gdq3.92bc435.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/gdq3.png
// module id = USgm
// module chunks = 0